import PropTypes from 'prop-types'
import {Text, Button, Box, Flex} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'

import {
  conversionRatePartnerShape,
  conversionRateValues,
} from './conversionRate'
import TermsLinks from './TermsLinks'
import TermsModal from './TermsModal'
import AuthoriseCheckbox from './AuthoriseCheckbox'
import MembershipDetails from './MembershipDetails'

const ActiveState = ({
  partner,
  memberBusinessName,
  abn,
  isSubmitting,
  onSubmit,
  onCancel,
  onShowTermsModal,
  agreed,
  toggleAgreed,
  connectDisabled,
}) => {
  const {t} = useTranslation('points')

  return (
    <Flex direction="column" justify="space-between" height="100%">
      <Box>
        <Box>
          <Text>
            {t(
              'points:qantasConnectionDrawer.activeState.title',
              conversionRateValues(partner),
            )}
          </Text>
        </Box>

        <TermsModal onShowTermsModal={onShowTermsModal} />

        <MembershipDetails memberBusinessName={memberBusinessName} abn={abn} />
      </Box>
      <Box>
        <Box py="md" borderBottom="1px solid" borderColor="mld.neutral.100">
          <TermsLinks />
        </Box>

        <Box py="md" borderBottom="1px solid" borderColor="mld.neutral.100">
          <AuthoriseCheckbox agreed={agreed} toggle={toggleAgreed} />
        </Box>

        <Box my="md">
          <Button
            mr="sm"
            variant="primary"
            onClick={onSubmit}
            isDisabled={connectDisabled}
            isLoading={isSubmitting}
          >
            {t('points:qantasConnectionDrawer.activeState.submit')}
          </Button>
          <Button variant="tertiary" onClick={onCancel}>
            {t('points:connectionDrawer.buttons.cancel')}
          </Button>
        </Box>
      </Box>
    </Flex>
  )
}

ActiveState.propTypes = {
  partner: conversionRatePartnerShape,
  memberBusinessName: PropTypes.string.isRequired,
  abn: PropTypes.string.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onShowTermsModal: PropTypes.func.isRequired,
  agreed: PropTypes.bool.isRequired,
  toggleAgreed: PropTypes.func.isRequired,
  connectDisabled: PropTypes.bool.isRequired,
}

ActiveState.defaultProps = {
  partner: null,
}

export default ActiveState
